var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 51,
    rx: 25.5,
    fill: "#4A93CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 24.5312H37.1562C37.4132 24.5312 37.6596 24.6333 37.8413 24.815C38.0229 24.9967 38.125 25.2431 38.125 25.5C38.125 25.7569 38.0229 26.0033 37.8413 26.185C37.6596 26.3667 37.4132 26.4688 37.1562 26.4688H17.7812C17.5243 26.4688 17.2779 26.3667 17.0962 26.185C16.9146 26.0033 16.8125 25.7569 16.8125 25.5C16.8125 25.2431 16.9146 24.9967 17.0962 24.815C17.2779 24.6333 17.5243 24.5312 17.7812 24.5312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1823 25.5L26.2171 33.5329C26.3991 33.7148 26.5012 33.9615 26.5012 34.2188C26.5012 34.476 26.3991 34.7227 26.2171 34.9046C26.0352 35.0865 25.7885 35.1887 25.5313 35.1887C25.274 35.1887 25.0273 35.0865 24.8454 34.9046L16.1266 26.1859C16.0364 26.0959 15.9649 25.989 15.916 25.8713C15.8672 25.7536 15.842 25.6274 15.842 25.5C15.842 25.3726 15.8672 25.2464 15.916 25.1287C15.9649 25.011 16.0364 24.9041 16.1266 24.8141L24.8454 16.0954C25.0273 15.9135 25.274 15.8113 25.5313 15.8113C25.7885 15.8113 26.0352 15.9135 26.2171 16.0954C26.3991 16.2773 26.5012 16.524 26.5012 16.7813C26.5012 17.0385 26.3991 17.2852 26.2171 17.4671L18.1823 25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPrevArrow);
export default __webpack_public_path__ + "static/media/slider-prev-arrow.07d66790aa62561175c1d507b77d1665.svg";
export { ForwardRef as ReactComponent };